import {onUnmounted, ref} from 'vue';

/**
 * Composable to initialize an IntersectionObserver and unmount on component destruction.
 * Used to detect when an element is in view.
 * @param {Object} options - Options for the IntersectionObserver.
 * @returns {Object, Boolean} - Contains the IntersectionObserver instance and a ref indicating if the element is visible.
 */
export const useIntersectionObserver = (options) => {
  const isElementVisible = ref(false);

  const intersectionObserver = new IntersectionObserver((entries) => {
    if (!entries[0].isIntersecting) {
      isElementVisible.value = false;
      return;
    }
    isElementVisible.value = true;
  }, options);

  onUnmounted(() => {
    if (intersectionObserver) {
      intersectionObserver.disconnect();
    }
  });

  return {intersectionObserver, isElementVisible};
};
